import { useEffect } from 'react';
import { registerCoreProviders, resetPaletteIndexes } from '../../palette/providers/index';
import { startFrecencyFeeds } from '../../palette/frecencyFeeds';
import { resetFrecencyCache } from '../../palette/frecency';
import { closePalette } from './paletteOpenState';

/**
 * Called once from App.js. When the app is past the sign-in gate (`ready`),
 * the core providers and commands register and frecency starts listening to
 * every surface. Gated again (sign-out, expired claim) → the palette closes.
 * `auth:logout` drops the in-memory indexes and the frecency cache, so the
 * next account starts from its own (§3.3 "Per account").
 */
export default function usePaletteSetup({ ready }) {
  useEffect(() => {
    if (!ready) {
      closePalette({ restoreFocus: false });
      return undefined;
    }
    registerCoreProviders();
    const stopFeeds = startFrecencyFeeds();
    return () => stopFeeds();
  }, [ready]);

  useEffect(() => {
    const onLogout = () => {
      closePalette({ restoreFocus: false });
      resetPaletteIndexes();
      resetFrecencyCache();
    };
    window.addEventListener('auth:logout', onLogout);
    return () => window.removeEventListener('auth:logout', onLogout);
  }, []);
}
